import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import './index.css';

// Get the root container
const container = document.getElementById('root');

// Create a Root object
const root = createRoot(container!);

// Render the app in strict mode
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
